import React from "react";
import { useLayoutStyles } from "../../styles";
import Navbar from '../shared/Navbar';
import SEO from '../shared/Seo';

function Layout({ children, title, marginTop = 60, minimalNavBar = false }) {
  const classes = useLayoutStyles();

  return (
      <section className={classes.section}>
        <SEO title={title}/>
        <Navbar minimalNavBar={minimalNavBar} />
        <main className={classes.main} style={{marginTop}}>
          <section className={classes.childrenWrapper}>
            <div className={classes.children}>
              {children}
            </div>
          </section>
        </main>
      </section>
    );
}

export default Layout;
